var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "setup-connection-modal",
          "data-backdrop": "static",
          role: "dialog",
          "aria-labelledby": "setup-connection-modal-label",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "setup-connection-modal-label" },
                  },
                  [_vm._v("\n            Setup Salsify Connection\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: { click: _vm.handleClose },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "card w-100" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "organization-id" } }, [
                        _vm._v("Organization ID"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.organizationId,
                            expression: "organizationId",
                          },
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.organizationId },
                        attrs: {
                          type: "text",
                          placeholder: "Enter organization ID",
                        },
                        domProps: { value: _vm.organizationId },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.organizationId = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.organizationId
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.errors.organizationId) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "auth-token" } }, [
                        _vm._v("API Key"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authToken,
                            expression: "authToken",
                          },
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.authToken },
                        attrs: { type: "text", placeholder: "Enter API Key" },
                        domProps: { value: _vm.authToken },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.authToken = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.authToken
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.errors.authToken) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer d-flex justify-content-between" },
                [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "info-btn",
                        attrs: { href: "#" },
                        on: { click: _vm.showInfoModal },
                      },
                      [
                        _vm._v(
                          "\n              Where do I find this information?\n            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("\n              Close\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", disabled: _vm.isLoading },
                        on: { click: _vm.handleConfirm },
                      },
                      [
                        _vm.isLoading
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status", "aria-hidden": "true" },
                            })
                          : _vm._e(),
                        _vm._v("\n              Confirm\n            "),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "salsify-info-modal",
          role: "dialog",
          "aria-labelledby": "salsify-info-modal-label",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-xl",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "salsify-info-modal-label" },
                  },
                  [
                    _vm._v(
                      "\n            How to Find Salsify API Information\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: { click: _vm.hideInfoModal },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body text-center" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: "/images/salsify/info-hint.png",
          alt: "Salsify API Information Guide",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }